import { Box, Button, CircularProgress, Stack, TextField } from '@mui/material'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { isEqual, isEmpty } from 'lodash'

import ToastAlert from '../../../../core/Layouts/ToastAlert'
import SideDialog from '../../components/SideDialog'
import DriverDrivesForm from './DriverDrivesForm'

export function DriverDrivesSettingDialog(props) {
	const {
		tileElementWidth,
		defaultTileWidth,
		tile,
		open,
		eventData,
		linkedFields,
		columnsChecked,
		otherOptionsChecked,
		isSubmitting,
		showStable,
		onClose,
		onSubmit,
		onResizeTileWidth,
		dashboardKeyList,
		firstLabel,
		secondLabel,
	} = props

	const { t } = useTranslation('common')

	const [alertInfo, setAlertInfo] = useState({
		open: false,
		text: '',
		type: 'success',
	})

	const [filterData, setFilterData] = useState({})

	const dialogWidth = tile?.w ?? 6
	const STABLE_WIDTH = 6

	useEffect(() => {
		if (isEqual(filterData.eventData, eventData)) return
		if (eventData) {
			setFilterData((prev) => ({ ...prev, eventData: eventData }))
		}
	}, [eventData])

	useEffect(() => {
		if (isEqual(filterData.linkedFields, linkedFields)) return
		if (linkedFields) {
			setFilterData((prev) => ({ ...prev, linkedFields: linkedFields }))
		}
	}, [linkedFields])

	useEffect(() => {
		if (isEqual(filterData.columnsChecked, columnsChecked)) return
		if (columnsChecked) {
			setFilterData((prev) => ({ ...prev, columnsChecked: columnsChecked }))
		}
	}, [columnsChecked])

	useEffect(() => {
		if (isEqual(filterData.otherOptionsChecked, otherOptionsChecked)) return
		if (otherOptionsChecked) {
			setFilterData((prev) => ({ ...prev, otherOptionsChecked: otherOptionsChecked }))
		}
	}, [otherOptionsChecked])

	useEffect(() => {
		if (!isEmpty(dashboardKeyList)) {
			const newPrimaryKeyList = dashboardKeyList
				.filter((item) => item.tileName === tile.i)
				.map((item) => item.key)
			setFilterData((prev) => ({ ...prev, primaryKeyList: newPrimaryKeyList }))
		}
	}, [dashboardKeyList])

	useEffect(() => {
		if (isEqual(filterData.firstLabel, firstLabel)) return
		if (firstLabel) {
			setFilterData((prev) => ({ ...prev, firstLabel: firstLabel }))
		}
	}, [firstLabel])

	useEffect(() => {
		if (isEqual(filterData.secondLabel, secondLabel)) return
		if (secondLabel) {
			setFilterData((prev) => ({ ...prev, secondLabel: secondLabel }))
		}
	}, [secondLabel])

	const handleFilterDataChange = (id, value) => {
		setFilterData((prev) => ({ ...prev, [id]: value }))
	}

	const handleSubmit = () => {
		onSubmit?.({
			eventData: filterData.eventData,
			linkedFields: filterData.linkedFields,
			columnsChecked: filterData.columnsChecked,
			otherOptionsChecked: filterData.otherOptionsChecked,
			primaryKeyList: filterData.primaryKeyList,
			firstLabel: filterData.firstLabel,
			secondLabel: filterData.secondLabel,
		})
	}

	return (
		<>
			<ToastAlert alertInfo={alertInfo} setAlertInfo={setAlertInfo} />

			<SideDialog
				defaultTileWidth={defaultTileWidth}
				open={open}
				onClose={onClose}
				width={showStable ? STABLE_WIDTH : dialogWidth}
				tileElementWidth={tileElementWidth}
				onResizeWidth={onResizeTileWidth}
			>
				<Stack
					sx={{
						'& .MuiInputBase-input': {
							fontSize: '0.9rem !important',
						},
						'& .MuiCheckbox-root': {
							p: 0,
						},
					}}
				>
					<Box sx={{ px: 1 }}>
						<TextField
							fullWidth
							id="label-basic"
							label={t('common:chart.labels')}
							variant="standard"
							value={tile.i}
							disabled={true}
							size="small"
						/>
					</Box>

					<Box sx={{ px: 1, mt: 2 }}>
						<DriverDrivesForm
							dashboardKeyList={dashboardKeyList}
							filterData={filterData}
							onFilterDataChange={handleFilterDataChange}
						/>
					</Box>

					<Stack direction="row" justifyContent="flex-end" mt={2}>
						<Stack spacing={2} direction="row">
							<Button
								size="small"
								variant="contained"
								onClick={handleSubmit}
								disabled={isSubmitting}
								startIcon={isSubmitting ? <CircularProgress color="inherit" size="1em" /> : null}
							>
								{t('common:misc.ok')}
							</Button>
							<Button size="small" variant="text" onClick={onClose}>
								{t('common:misc.cancel')}
							</Button>
						</Stack>
					</Stack>
				</Stack>
			</SideDialog>
		</>
	)
}

export default DriverDrivesSettingDialog
